// extracted by mini-css-extract-plugin
export default {"bio":"Bio_bio__a6+nz","bioLine":"Bio_bioLine__U4jxt","key":"Bio_key__0ynaf","value":"Bio_value__cxkNQ","linkValue":"Bio_linkValue__Daavv","link":"Bio_link__GWbOv"};